import SocialiteProvider from '@/enums/SocialiteProvider';

export default {
  data() {
    return {
      registrationPayload: {},
      socialiteProvider: SocialiteProvider,
    };
  },

  methods: {
    isSocialitePopupClosed(error) {
      return error?.type === 'popup_closed' // Google
        || error?.error === 'popup_closed_by_user'; // Apple
    },

    async socialiteSignIn(provider) {
      this.registrationPayload = {};

      switch (provider.value) {
        case this.socialiteProvider.google.value:
          return (await this.$gAuth.signIn?.())?.access_token;
        case this.socialiteProvider.facebook.value:
          if (window.FB?.init) {
            return window.FB.getAccessToken?.() ?? (await new Promise(window.FB.login)).authResponse.accessToken;
          }

          break;
        case this.socialiteProvider.apple.value:
          return this.appleSignIn();
        default:
          break;
      }

      return null;
    },

    async socialiteSignOut(provider) {
      return this.$store.dispatch('socialite/providerSdkLogout', {
        component: this,
        provider_type: provider.value,
      });
    },

    async appleSignIn() {
      const response = await this.$appleAuth.signIn?.();
      const accessToken = response?.authorization?.id_token;

      // Laravel Socialite doesn't fetch the Apple ID account name so capture
      // it from the JS SDK for user registration. Apple will only provide
      // `response.user` when the account is first authorized for our app.
      if (accessToken && response.user) {
        this.registrationPayload = {
          first_name: response.user.name?.firstName,
          last_name: response.user.name?.lastName,
        };
      }

      return accessToken;
    },
  },
};
